var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGraphView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    width: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.3050848,0,-3.661017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 23,8 c 0,1.1 -0.9,2 -2,2 -0.18,0 -0.35,-0.02 -0.51,-0.07 l -3.56,3.55 C 16.98,13.64 17,13.82 17,14 c 0,1.1 -0.9,2 -2,2 -1.1,0 -2,-0.9 -2,-2 0,-0.18 0.02,-0.36 0.07,-0.52 L 10.52,10.93 C 10.36,10.98 10.18,11 10,11 9.82,11 9.64,10.98 9.48,10.93 L 4.93,15.49 C 4.98,15.65 5,15.82 5,16 5,17.1 4.1,18 3,18 1.9,18 1,17.1 1,16 c 0,-1.1 0.9,-2 2,-2 0.18,0 0.35,0.02 0.51,0.07 L 8.07,9.52 C 8.02,9.36 8,9.18 8,9 8,7.9 8.9,7 10,7 c 1.1,0 2,0.9 2,2 0,0.18 -0.02,0.36 -0.07,0.52 l 2.55,2.55 C 14.64,12.02 14.82,12 15,12 c 0.18,0 0.36,0.02 0.52,0.07 L 19.07,8.51 C 19.02,8.35 19,8.18 19,8 c 0,-1.1 0.9,-2 2,-2 1.1,0 2,0.9 2,2 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphView);
export default __webpack_public_path__ + "static/media/iconGraphView.05600b61d8003aa73d0bb5dc6e57033e.svg";
export { ForwardRef as ReactComponent };